import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { ICapacityEvaluationRepository } from '@/api/fe-api/domain/repositories/capacity-evaluation.repository';

export namespace GetSohData {
  export const key = (input: Input) => [
    'capacity-evaluation',
    'get-soh-data',
    ...Object.entries(input).flatMap(([key, value]) => [key, value]),
  ];

  export type Params = { refetchInterval?: number };
  export type Input = ICapacityEvaluationRepository.GetSohDataInput;
  export type Output = ICapacityEvaluationRepository.GetSohDataOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.capacityEvaluation.getSohData(input),
    });
  }
}
